export default __webpack_public_path__ + "static/bomb-small-89158d7f0b1a7d0391c3afc5e699b56b.png";